import styled from 'styled-components';
import brandConfig from '../config/brand';
import { Link } from 'react-router-dom';

export const NotFound = () => {
  return (
    <Container>
      <Wrapper>
        <Logo src={brandConfig.logo} alt={`${brandConfig.displayName} logo`} />
        <h1>404 Not Found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
        <StyledLink to="/">Back to Home</StyledLink>
      </Wrapper>
    </Container>
  );
};

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
`;

const Logo = styled.img`
  width: 100px;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  width: 100%;
  background-color: #f5f5f5;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;
